import sal from 'sal.js'

export default function initSal(){
  sal()
}
